// Core
import {useHistory} from 'react-router-dom';
import {useState, useCallback} from 'react';
import {useQuery} from 'react-query';
import {FaPlus} from 'react-icons/fa6';

// Chakra imports
import {
    Button,
    SimpleGrid,
    Flex,
    useDisclosure,
} from '@chakra-ui/react';

// Assets
import {apiService} from 'services/ApiService';

// Components
import Pagination from 'components/Pagination';
import RoleRow from './components/RoleRow';
import NotFound from 'views/Dashboard/404.js';
import ErrorCard from 'components/Errors';
import usePermissionStatusByKey from '../../../../hooks/usePermissionStatusByKey';

function Roles() {
    const [data, setData] = useState([]);
    const [newObjectErrors, setNewObjectErrors] = useState([]);
    const [newObject, setNewObject] = useState({});
    const [isLoadingPage, setIsLoadingPage] = useState(false);
    const [errorCard, setErrorCard] = useState();
    const [offset, setOffset] = useState(0);

    const {refetch, isFetching} = useQuery({
        queryKey: ['data-roles'],
        refetchOnWindowFocus: false,
        queryFn: async () => {
            const response = await apiService.getRoles();
            setData(response.data);
            setIsLoadingPage(false);
            return true;
        },
        retry: false
    });

    const history = useHistory();
    const onNewButtonClicked = useCallback(() => {
        history.push('/permissions/roles/new');
    }, [history]);

    const onRowClicked = useCallback((item) => {
        history.push(`/permissions/roles/${item.id}`);
    }, [history]);

    const handleDelete = async (item) => {
        console.log('handleDelete', handleDelete);
        try {
            const response = await apiService.deleteRole(item);
            if (response.data === false || response.statusCode !== 200) {
                setErrorCard(response.message);
                return;
            }

            setNewObject({});
            window.location.reload();
        } catch (e) {
            setErrorCard(true);
            return;
        }
    };

    const isCapabilities = usePermissionStatusByKey('GET:/admin/roles/capabilities');
    const isCreateRole = usePermissionStatusByKey('POST:/admin/roles');

    return (
        <>
            {isCreateRole && isCapabilities && <Flex position="absolute" right="0" top="80px" mr="31px" gap="12px">
                <Button variant="submit-ms" w="150px" onClick={onNewButtonClicked} leftIcon={<FaPlus/>}>Role</Button>
            </Flex>}

            {errorCard && (<ErrorCard error={errorCard} maxW="100%"/>)}

            {data?.length > 0 ? (
                <>
                    <SimpleGrid columns={{base: 1, md: 3}} spacing="8px" opacity={isLoadingPage ? '0.3' : '1'}>
                        {data?.map(item => (
                            <RoleRow handleEditOpen={onRowClicked} key={item?.id} item={item}
                                     handleDelete={handleDelete}/>
                        ))}
                    </SimpleGrid>
                </>
            ) : (
                <NotFound text={isFetching ? 'Loading...' : 'Not found'}/>
            )
            }

        </>
    );
}

export default Roles;